<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-card-title primary-title>
          Page List
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-card-text>
          
          <v-data-table
            :search="search"
            :headers="headers"
            :items="pages"
            :items-per-page="5"
            :sort-by="['name']"
            class="elevation-1"
            :loading="loading"
            hide-default-footer
            :disable-pagination="true"
          >
            <template v-slot:item.action="{ item }">
              <v-btn 
                @click="selectItem(item)"
                rounded
                 small color="success">
                Select
              </v-btn>
            </template>
          </v-data-table>
          
        </v-card-text>
        <v-card-actions class="d-flex flex-row-reverse">
          <v-btn 
            @click="refreshScripts" 
            rounded color="primary" 
            style="margin: 10px"
            :loading="generateButtonLoading"
            :disabled="generateButtonLoading"
          >
            Refresh All Scripts
          </v-btn>

          <app-page-new
            :siteId="siteId"
          >
          </app-page-new>
          <!--<v-btn @click="newItem" rounded color="secondary" style="margin: 10px">Nouveau</v-btn>-->
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import PageNew from './PageNew.vue'
  export default {
    components: {
      AppPageNew: PageNew
    },
    props: ['siteId'],
    data(){
      return {
        headers: [
          {text: 'Id', align: 'left', value : 'id'},
          {text: 'Name', align: 'left', value: 'name'},
          {text: 'Action', align: 'right', value: 'action'}
        ],
        pages: [],
        search: "",
        loading: false,
        generateButtonLoading: false
      }
    },
    created(){
      this.getDataFromApi()
    },
    methods: {
      async getDataFromApi() {
        this.loading = true
        const request = {
          type : "management/page",
          action : "index",
          data: { siteId : this.siteId }
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.pages = response.data
          this.loading = false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.loading = false  
        }
      },
      async refreshScripts(){
        this.generateButtonLoading = true
        const request = {
          type : "management/page",
          action : "refreshScriptsForSiteId",
          data: { siteId : this.siteId }
        }
        try {
          const accessToken = await this.$auth.getAccessToken()
          await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.generateButtonLoading = false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.generateButtonLoading = false  
        }
      },
      selectItem(item){
        this.$router.push('/management/page/'+item.id+'/general') //&adtype=display&device=desktop
      },
      newItem(){
        this.$router.push('/management/'+this.siteId+'/page/new/general')
      }
    }
  }
</script>